"use strict";
/*
 * Created on 18. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * National or local pricing.
 * @author Radek Beran
 */

var PricingType;

(function (PricingType) {
  PricingType["National"] = "National";
  PricingType["Local"] = "Local";
})(PricingType = exports.PricingType || (exports.PricingType = {}));